import { HttpContextToken } from '@angular/common/http';

export const SUPPRESS_HTTP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
